<template>
    <b-container fluid>
                
        <PortalNavbar show="true"></PortalNavbar>
        <!-- <b-container> -->
        <!-- <b-row text-align="center">
            <b-col md="5" sm="12" class="p-2 mx-5"  v-for="board in Boards" :key="board.BoardName">
                <b-card class="box">
                    
                    <h4 class="media-heading">{{board.SecurityBoardName}}</h4>
                    <hr/>
                    <b-row>
                        <b-col sm="3"><p><b>Chairman</b>:</p></b-col>
                        <b-col><p>{{board.Chairman}}</p></b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="3"><p><b>Secretary</b>:</p></b-col>
                        <b-col><p>{{board.Secretary}}</p></b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="3"><p><b>Address</b>:</p></b-col>
                        <b-col><p>{{board.Address}}</p></b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="3"><p><b>Email</b>:</p></b-col>
                        <b-col><p>{{board.Email}}</p></b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="3"><p><b>Tel.No</b>:</p></b-col>
                        <b-col><p>{{board.LandlineNumber}}/{{board.LandlineNumber1}}</p></b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="3"><p><b>Fax.No</b>:</p></b-col>
                        <b-col><p>{{board.FAX}}</p></b-col>
                    </b-row>
                                        
                </b-card>
            </b-col>
        </b-row> -->
        <b-row>
            <b-col></b-col>
            <b-col>
                <p class="text-justify mt-4"><strong>For Technical Queries Contact :</strong></p>
                       
                <p class="text-justify mt-2"><strong>Technical Support Team</strong></p>
                                <p>Tel. No. 022-2620 2586</p>
                                <p>Tel. No. 022-2620 2588</p>

            </b-col>
            <b-col></b-col>
        </b-row>
              
        <!-- </b-container> -->
    </b-container>
</template>

<script>
import PortalNavbar from "@/components/PortalNavbar";
import apis from "@/apis";
export default {
    components: { PortalNavbar},
    data(){
        return{
            Boards:[
            ]
        }
    },
    mounted(){
        // let promise = apis.readSGBoardName();

        // promise.then(response =>{
        //     if(response.status==200)
        //     {
        //         this.Boards = response.body;
        //     }
        // })
    }

}
</script>

<style scoped>

 .box{ 
box-sizing:border-box;
border: 1px solid blue;
border-radius: 4px;
box-shadow: 7px 5px 4px rgba(0,0,0,0.5);
overflow: hidden;
min-height:230px
 } 
.box h1{
    font: 400 20px/22px "Open sans", sans-serif;
    text-align: center;
    color: blue;
}
.box p{
    margin-left:5px;
    font:400 14px "Open sans", sans-serif;
    color: #555555;
    /* text-align: center;  */
}
.box b{
    color: #090909;
 } 

</style>



// WEBPACK FOOTER //
// src/components/Portal/Contact.vue